import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

export interface AttendanceJustificationResolutionDialogData {
  title: string;
  message: string;
  commentLabel: string;
  commentPlaceholder?: string;
  confirmLabel: string;
  cancelLabel: string;
  required?: boolean;
  initialComment?: string;
}

@Component({
  selector: 'app-attendance-justification-resolution-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, TranslateModule],
  templateUrl: './attendance-justification-resolution-dialog.component.html',
  styleUrl: './attendance-justification-resolution-dialog.component.scss',
})
export class AttendanceJustificationResolutionDialogComponent {
  comment = '';

  constructor(
    private readonly dialogRef: MatDialogRef<AttendanceJustificationResolutionDialogComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) public readonly data: AttendanceJustificationResolutionDialogData
  ) {
    this.comment = data.initialComment || '';
  }

  get canConfirm(): boolean {
    return !this.data.required || !!this.comment.trim();
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    if (!this.canConfirm) {
      return;
    }
    this.dialogRef.close(this.comment.trim() || '');
  }
}
